import { FeatureFlag } from '../FeatureFlag';

export const showRecentlyUsedIdeaIndicators = new FeatureFlag({
    key: 'show-recently-used-idea-indicators',
    defaultValue: false,
});
